import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { getMentionLabel } from 'utlis/chatPrototype';

import styles from './styles.module.scss';

export function MentionMenu({ options, highlightedIndex, position, onHover, onSelect }) {
  const itemRefs = useRef([]);

  useEffect(() => {
    itemRefs.current[highlightedIndex]?.scrollIntoView({ block: 'nearest' });
  }, [highlightedIndex]);

  return (
    <div
      className={styles['mention-menu']}
      style={position}
      role="listbox"
      onMouseDown={event => event.preventDefault()}
    >
      <div className={styles['mention-menu__list']}>
        {options.length === 0 && (
          <p className={styles['mention-menu__empty']}>
            No matching new ideas
          </p>
        )}
        {options.map((option, index) => (
          <button
            key={option.insightUuid}
            ref={element => {
              itemRefs.current[index] = element;
            }}
            type="button"
            role="option"
            aria-selected={highlightedIndex === index}
            className={cn(styles['mention-menu__item'], {
              [styles['mention-menu__item--highlighted']]: highlightedIndex === index,
            })}
            onMouseEnter={() => onHover(index)}
            onMouseLeave={() => onHover(-1)}
            onMouseDown={() => onSelect(option)}
          >
            <span className={styles['mention-menu__title']}>
              {getMentionLabel(option)}
            </span>
            <span className={styles['mention-menu__description']}>
              {option.description}
            </span>
          </button>
        ))}
      </div>
      <div className={styles['mention-menu__footer']}>
        1 credit
      </div>
    </div>
  );
}

MentionMenu.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    insightUuid: PropTypes.string.isRequired,
    feedbackId: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
  })).isRequired,
  highlightedIndex: PropTypes.number.isRequired,
  position: PropTypes.shape({
    left: PropTypes.number,
    bottom: PropTypes.number,
  }).isRequired,
  onHover: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};
